import PropTypes from 'prop-types';

import Container, { ContainerProps as MuiContainerProps } from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { ResetPassword as ResetPasswordForm } from '@classity-edtech/ui-auth';
import { useNavigate, useParams } from 'react-router-dom';
import Helmet from '../../components/Helmet';

export interface ResetPasswordProps extends MuiContainerProps {}

export const ResetPassword = ({ className }: ResetPasswordProps) => {
  const navigate = useNavigate();
  const { token } = useParams();

  const handleNavigation = (path: string) => {
    navigate(`/${path}${path === 'signin' ? `?isPasswordRenewed=true` : ''}`);
  };

  return (
    <>
      <Helmet />
      <ResetPasswordForm navigate={handleNavigation} token={token} />
    </>
  );
};

ResetPassword.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ResetPassword.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(ResetPassword)(
  ({ theme }) => `
`,
);
